export const ACCESS_TOKEN = 'Access-Token'
export const USER_NAME = 'Login_Username'
export const USER_INFO = 'Login_Userinfo'